/* istanbul ignore file */
import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";

import {
  ISecurityRoleMembersByTenantRequest,
  ISecurityRoleMembersByEnterpriseRequest,
  ISecurityRoleMembersResponse,
  ISecurityRoleMembersRevokeRoleRequest,
  IGrantRoleRequest
} from "./SecurityRoleMembers.api.types";

export const getSecurityRoleMembersByEnterprise = async (request: ISecurityRoleMembersByEnterpriseRequest): Promise<ISecurityRoleMembersResponse[]> => {
  return (await getClientFor(mainApi.name).get(`/security-roles/${request.securityRoleId}/enterprises/${request.enterpriseId}`)).data;
};

export const getSecurityRoleMembersByTenant = async (request: ISecurityRoleMembersByTenantRequest): Promise<ISecurityRoleMembersResponse[]> => {
  return (await getClientFor(mainApi.name).get(`/security-roles/${request.securityRoleId}/tenants/${request.tenantId}`)).data;
};

export const grantRole = async (request: IGrantRoleRequest): Promise<any> => {
  return (await getClientFor(mainApi.name).post(`/security-roles/`, request)).data;
};

export const revokeSecurityRole = async (request: ISecurityRoleMembersRevokeRoleRequest[]) =>
  (await getClientFor(mainApi.name).delete("/security-roles/bulk-revoke", { data: request })).data;
